import { get } from '@lumapps/constants';
import { customerSelector } from '@lumapps/customer/ducks/selectors';
import { isFeatureEnabled } from '@lumapps/features';
import { getCurrentInstance } from '@lumapps/instance/ducks/selectors';
import { useSelector } from '@lumapps/redux/react';
import { currentLanguageSelector } from '@lumapps/translations/ducks/selectors';
import { connectedUserSelector, hasAcceptedCookiesSelector, isUserImpersonated } from '@lumapps/user/ducks/selectors';

const { isDev } = get();

/**
 * Hook regrouping all metrics configs (used in legacy and in Metrics component)
 */
export const useMetricsConfig = () => {
    const isPendoEnabled = useSelector(isFeatureEnabled('pendo-analytics')) && !isDev;
    const customer = useSelector(customerSelector);
    const instance = useSelector(getCurrentInstance);
    const user = useSelector(connectedUserSelector);
    const isUserImpersonatedValue = useSelector(isUserImpersonated);
    const currentLanguage = useSelector(currentLanguageSelector);
    const hasAcceptedCookies = useSelector(hasAcceptedCookiesSelector);

    return { isPendoEnabled, customer, instance, user, isUserImpersonatedValue, currentLanguage, hasAcceptedCookies };
};
